import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const House: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 53 53"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M29.4557 1.92482L29.4556 1.9247C28.6652 1.13403 27.6179 0.7 26.5003 0.7C25.3826 0.7 24.3353 1.13371 23.5445 1.92441L23.0936 1.47346L23.5445 1.92441L1.93395 23.5324C1.93395 23.5324 1.93314 23.5332 1.92967 23.5368L1.91344 23.5533C0.292742 25.1832 0.29568 27.8291 1.92132 29.4546L1.92143 29.4547C2.66468 30.1982 3.64428 30.6281 4.69441 30.6732L4.71342 30.674L4.73236 30.6758C4.75925 30.6784 4.78671 30.6798 4.81483 30.6798H5.67661H6.37661V31.3798V47.2901C6.37661 50.0517 8.62494 52.3 11.3879 52.3H19.8472C20.3181 52.3 20.7 51.9181 20.7 51.4473V38.9736C20.7 37.1503 22.1822 35.6684 24.0056 35.6684H28.9951C30.8184 35.6684 32.3006 37.1503 32.3006 38.9736V51.4473C32.3006 51.9182 32.6823 52.3 33.1535 52.3H41.6127C44.3757 52.3 46.6241 50.0517 46.6241 47.2901V31.3798V30.6798H47.3241H48.1231C49.2404 30.6798 50.2878 30.2461 51.079 29.4553C52.7062 27.827 52.707 25.1769 51.0813 23.5474L29.4557 1.92482ZM29.4557 1.92482L51.0777 23.5438L51.0777 23.5438L51.0808 23.5469L29.4557 1.92482Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="1.4"
      />
    </svg>
  )
})

House.displayName = 'House'
